import type { FeatureEvents, ScreenEvent, UIEvent } from '../new-analytics-types';
import { Action, ActionSubject } from '../new-analytics-types';

type ScreenKeys = 'featureSettingsTabScreenViewed';

type UIEventKeys = 'earlyAccessFeaturesToggleToggled';

type TrackEventKeys = string;

type OperationalEventKeys = string;

export const featureSettingsTabScreen = 'featureSettingsTabScreen';

export const featureSettingsEvents: FeatureEvents<ScreenKeys, UIEventKeys, TrackEventKeys, OperationalEventKeys> = {
  confluenceSpec: 'https://hello.atlassian.net/wiki/spaces/cffd/pages/5633902405/Experiment+Instrumentation+-+AI+first+create+onboarding',
  screen: {
    featureSettingsTabScreenViewed: (): ScreenEvent => ({
      data: {
        name: featureSettingsTabScreen,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/89194',
    }),
  },
  ui: {
    earlyAccessFeaturesToggleToggled: (attributes: { enabled: boolean }): UIEvent => ({
      data: {
        action: Action.Toggled,
        actionSubject: ActionSubject.Toggle,
        actionSubjectId: 'earlyAccessFeaturesToggle',
        source: featureSettingsTabScreen,
        attributes,
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/89195',
    }),
  },
  track: {},
  operational: {},
};
